import React, { useState, useEffect } from 'react';
import { Container, Alert, Table, Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { buildUrl, formatDouble } from '../helper/handler';
import { getFromApi, postToApi } from '../utilities/NetUtilities';
import { SpinnerComp } from '../helper/spinner';
import Obiettivo730Form from './Obiettivo730Form';
import moment from 'moment';

function GestioneObiettivi730() {
    const [obiettivi, setObiettivi] = useState([]);
    const [message, setMessage] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentObiettivo, setCurrentObiettivo] = useState(null);
    const [organizzazione, setOrganizzazione] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        if (organizzazioneMap) {
            setOrganizzazione(organizzazioneMap);
            loadObiettivi(organizzazioneMap);
        }
    },[]);

    const loadObiettivi = (org) => {
        const setObiettiviFromApi = (data) => {
            setObiettivi(data.obiettivi ||[]);
            setLoading(false);
        };
        const params = { organizzazione: org.nome, tipo: org.tipo, tutti: true };
        getFromApi(buildUrl('obiettivi730', params), setObiettiviFromApi, setMessageFromApi);
    };

    const setMessageFromApi = (data) => {
        setMessage([]);
        if (data.messaggi) {
            data.messaggi.forEach((value) => {
                setMessage(prevMessage => [...prevMessage, {
                    descrizione: value.descrizione,
                    tipo: value.tipo.toLowerCase()
                }]);
            });
        }
        setShowModal(false);
        setLoading(false);
    };

    const handleShowModal = (obiettivo) => {
        setMessage([]);
        setCurrentObiettivo(obiettivo);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setCurrentObiettivo(null);
        setShowModal(false);
    };

    const action = (data) => {
        setMessage([]);
        if (data.messaggi) {
            data.messaggi.forEach((value) => {
                setMessage(prevMessage => [...prevMessage, {
                    descrizione: value.descrizione,
                    tipo: value.tipo.toLowerCase()
                }]);
            });
        }
        loadObiettivi(organizzazione);
        setShowModal(false);
    };

    const handleSaveObiettivo = (obiettivo) => {
        const obiettivoUpdated = { ...obiettivo, organizzazione: organizzazione.nome, tipoOrganizzazione: organizzazione.tipo };
        const url = buildUrl(currentObiettivo ? 'editobiettivo730' : 'addobiettivo730');
        postToApi(url, obiettivoUpdated, action, setMessageFromApi);
    };

    const okActionDelete = (data) => {
        loadObiettivi(organizzazione);
        setMessageFromApi(data);
    };

    const handleDeleteObiettivo = (id) => {
        const url = buildUrl('deleteobiettivo730');
        postToApi(url, { id: id }, okActionDelete, setMessageFromApi);
    };

    const formatDate = (dateStr) => {
        return moment(dateStr).format('DD/MM/YYYY');
    };

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}><SpinnerComp /></div>;
    }

    return (
        <div className='main' role="main">
            <div>
                <h1 className="d-flex justify-content-center inEvidenza" id="title_gestione_obiettivi_730">Gestione obiettivi 730</h1>
                {message && message.map((data, key) => (
                    <Alert variant={data.tipo} id="message" key={key}>
                        {data.descrizione}
                    </Alert>
                ))}
                <Container>
                    <div className="d-flex justify-content-between mb-2">
                        <Button id="indietro_gestione_obiettivi_730" className="btnGenerale" variant="flat" size="sm" as={Link} to="/obiettivi730">
                            Indietro
                        </Button>
                        <Button id="aggiungi_obiettivo_730" className="btnGenerale" variant="flat" size="sm" onClick={() => handleShowModal(null)}>
                            Aggiungi obiettivo
                        </Button>
                    </div>
                    {obiettivi.length > 0 ? (
                        <Table id="tabella_obiettivi_730" striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="inEvidenza App">Data obiettivo</th>
                                    <th className="inEvidenza App">Percentuale rispetto al totale dell'anno precedente</th>
                                    <th className="inEvidenza App">Data disponibilità</th>
                                    <th className="inEvidenza App">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                {obiettivi.map((obiettivo, index) => (
                                    <tr key={obiettivo.id}>
                                        <td>{formatDate(obiettivo.dataObiettivo)}</td>
                                        <td>{formatDouble(obiettivo.percentualeIncremento)}%</td>
                                        <td>{formatDate(obiettivo.dataDisponibilita)}</td>
                                        <td>
                                            <div className="actionIconContainer">
                                                <FaEdit id={`modifica_obiettivo_${index}`} title='modifica obiettivo' className='actionIcon' onClick={() => handleShowModal(obiettivo)} />
                                                <FaTrash id={`elimina_obiettivo_${index}`} title='elimina obiettivo' className='actionIcon' onClick={() => handleDeleteObiettivo(obiettivo.id)} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Row className="justify-content-center">
                            <Col xs={12} className="text-center">
                                <p id="obiettivi_assenti">Non ci sono obiettivi.</p>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{currentObiettivo ? 'Modifica obiettivo' : 'Aggiungi obiettivo'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Obiettivo730Form obiettivo={currentObiettivo} onSave={handleSaveObiettivo} onClose={handleCloseModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default GestioneObiettivi730;